import React, { useState, useEffect } from 'react';
import { db } from '../../firebase';
import { collection, addDoc, deleteDoc, doc, onSnapshot, query, updateDoc } from 'firebase/firestore';
import { Play, Pause, Trash2, Plus, Volume2 } from 'lucide-react';

export default function AdManager() {
  const [campaigns, setCampaigns] = useState<any[]>([]);
  const [newCampaign, setNewCampaign] = useState({ audioUrl: '', frequencyMinutes: 15, targetedRegions: 'generic', active: true });
  const [audioElement, setAudioElement] = useState<HTMLAudioElement | null>(null);
  const [isPlaying, setIsPlaying] = useState<string | null>(null);

  useEffect(() => {
    const q = query(collection(db, 'ad_campaigns'));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setCampaigns(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });
    return unsubscribe;
  }, []);

  const handleCreate = async () => {
    if (!newCampaign.audioUrl) return;
    await addDoc(collection(db, 'ad_campaigns'), {
      ...newCampaign,
      targetedRegions: newCampaign.targetedRegions.split(',').map(s => s.trim()),
      lastPlayedAt: 0
    });
    setNewCampaign({ audioUrl: '', frequencyMinutes: 15, targetedRegions: 'generic', active: true });
  };

  const togglePlay = (url: string, id: string) => {
    if (isPlaying === id) {
      audioElement?.pause();
      setIsPlaying(null);
    } else {
      if (audioElement) audioElement.pause();
      const audio = new Audio(url);
      audio.onended = () => setIsPlaying(null);
      audio.play();
      setAudioElement(audio);
      setIsPlaying(id);
    }
  };

  const deleteCampaign = async (id: string) => {
    await deleteDoc(doc(db, 'ad_campaigns', id));
  };

  return (
    <div className="space-y-6">
      <div className="bg-zinc-950 p-4 border border-zinc-800 rounded-xl space-y-3">
        <h3 className="text-xs font-bold text-zinc-500 uppercase">Nueva Campaña de Publicidad</h3>
        <input type="text" value={newCampaign.audioUrl} onChange={e => setNewCampaign({...newCampaign, audioUrl: e.target.value})} placeholder="URL del Audio (ej: media.auradisplay.es/ads/publi1.mp3)" className="w-full bg-zinc-900 border border-zinc-800 rounded-lg p-2.5 text-xs" />
        <div className="grid grid-cols-2 gap-2">
            <input type="number" value={newCampaign.frequencyMinutes} onChange={e => setNewCampaign({...newCampaign, frequencyMinutes: parseInt(e.target.value)})} placeholder="Frecuencia (min)" className="bg-zinc-900 border border-zinc-800 rounded-lg p-2.5 text-xs" />
            <input type="text" value={newCampaign.targetedRegions} onChange={e => setNewCampaign({...newCampaign, targetedRegions: e.target.value})} placeholder="Regiones (csv)" className="bg-zinc-900 border border-zinc-800 rounded-lg p-2.5 text-xs" />
        </div>
        <button onClick={handleCreate} className="w-full py-2.5 rounded-lg bg-yellow-500 text-black font-bold text-[10px] uppercase tracking-widest hover:bg-yellow-400 flex items-center justify-center gap-2">
            <Plus size={14} /> Crear Campaña
        </button>
      </div>

      <div className="space-y-2">
        {campaigns.map(camp => (
          <div key={camp.id} className="bg-zinc-950 p-3 rounded-lg border border-zinc-800 flex items-center gap-3 text-xs">
            <button onClick={() => togglePlay(camp.audioUrl, camp.id)} className="p-2 rounded-full bg-zinc-800 hover:bg-zinc-700">
               {isPlaying === camp.id ? <Pause size={14} /> : <Play size={14} />}
            </button>
            <span className="flex-1 truncate">{camp.audioUrl}</span>
            <span className="text-zinc-500">{camp.frequencyMinutes}m</span>
            <span className="text-zinc-500">{camp.targetedRegions.join(', ')}</span>
            <button onClick={() => deleteCampaign(camp.id)} className="p-2 text-red-500 hover:bg-red-900/20 rounded-full">
                <Trash2 size={14} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
